export const en = {
    defaultTitle: `Action Result`,
    processingTitle: `Processing...`,
    processingDescription: `Please wait while we process your request`,
    success: `Action completed successfully`,
    error: `An error occurred`,
    unexpectedError: `An unexpected error occurred. Please try again.`,
    serverUnavailable: `Server is currently unavailable. Please try again later.`,
    networkUnavailable: `Unable to connect to the server. Please check your internet connection.`,
    redirect: `Redirecting in {count} seconds...`,
    continueNow: `Continue Now`,
};
//# sourceMappingURL=en.js.map